import { AxiosInstance } from 'axios'

import { userApiDefaultApiFactory } from '@src/api/default-api-factories'
import {
  DefaultApiSearchCorporationsInNationalTaxAgencyRequest,
  // Do Not Remove this line ===@import api type===
} from '@src/api/generated/user-api'

export const searchCorporationsInNationalTaxAgency = async (
  instance: AxiosInstance,
  params: DefaultApiSearchCorporationsInNationalTaxAgencyRequest
) => {
  return await userApiDefaultApiFactory(
    instance
  ).searchCorporationsInNationalTaxAgency(params)
}

// Do Not Remove this line ===@import api client===
